import privacyPolicyReducers from './privacyPolicy';

// Reducers object
const reducers = {
  ...privacyPolicyReducers,
};

export default reducers;
